/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/boat_medium'
export default icon
